import React, {Component} from 'react';
import {Link} from 'react-router';

import TheModernMarketer from '../components/brand_ambassadors/the_modern_marketer';
import PowerOfAuthenticity from '../components/brand_ambassadors/power_of_authenticity';
import ValueOfTechnology from '../components/brand_ambassadors/value_of_technology';
import CustomersIntoBrandAmbassadors from '../components/brand_ambassadors/customers_into_brand_ambassadors';
import UnparalleledBusinessBenefit from '../components/brand_ambassadors/unparalleled_business_benefit';
import TargetAutomateSave from '../components/brand_ambassadors/target_automate_save';
import EndlessPossibilities from '../components/endless_possibilities/';
import ImaginePossibilities from '../components/brand_ambassadors/imagine_possibilities';
import MeetTheTeam from '../components/meet_the_team/';
import ContactForm from '../components/contact_form';

export default class BrandAmbassadors extends Component {
    constructor(){
        super();
        this.adjustWindowSizeState = this.adjustWindowSizeState.bind(this);
        this.setInnerHeight = this.setInnerHeight.bind(this);
        this.setInnerPageWidth = this.setInnerPageWidth.bind(this);
        this.setIsMobile = this.setIsMobile.bind(this);
        this.setDisplayMode = this.setDisplayMode.bind(this);
        this.state = {
            isMobile: false,
            displayStatic: false,
            innerHeight: '100vh',
            innerPageWidth: null
        };
    }

    componentDidMount(){
        this.setInnerHeight();
        this.setInnerPageWidth();
        this.setIsMobile();
        this.setDisplayMode();

        window.addEventListener('resize', this.adjustWindowSizeState);
    }

    componentWillUnmount(){
        window.removeEventListener('resize', this.adjustWindowSizeState);
    }

    adjustWindowSizeState() {
        this.setIsMobile();
        this.setInnerPageWidth();
    }

    setInnerHeight(){
        const innerHeight = window.innerHeight;

        this.setState({
            innerHeight: `${innerHeight}px`
        });
    }

    setInnerPageWidth() {
        const innerPageWidth = window.innerWidth;

        this.setState({
            innerPageWidth
        });
    }

    setIsMobile(){
        // 769 is is the sm breakpoint defined by our gridle state
        const isMobile = window.innerWidth < 769;

        this.setState({
            isMobile
        });
    }

    setDisplayMode(){
        const isIE = /*@cc_on!@*/false || !!document.documentMode;

        this.setState({
            displayStatic: isIE
        });
    }

    returnBrandAmbassadorsHeroStyle(){
        const {isMobile, innerHeight} = this.state;

        if(isMobile){
            return {
                height: innerHeight
            };
        } else {
            return {
                height: '90rem'
            };
        }
    }

    render(){
        const {isMobile, displayStatic, innerPageWidth} = this.state;
        const snBlackLogo = require('images/sn_logo_black.png');
        const brandAmbassadorsHeroStyle = this.returnBrandAmbassadorsHeroStyle();

        return(
            <div id='brand-ambassadors'>
                <div className='container'>
                    <div className='gr-12 nav-filter'></div>
                    <div className='gr-12 brand-ambassadors-nav'>
                        <Link to='/'>
                            <img
                                src={snBlackLogo}
                                className='sn-logo' />
                        </Link>

                        <div className='launch-nav'>
                            <Link to='/'>BRANDED CONTENT</Link>
                        </div>

                        <Link to="/content_creator" className="hide show@sm content-creator-link-nav" />
                        <div id="are-you-a-content-creator" className="hide show@sm">
                            <div>
                                <span>Are you a</span>
                                <br/>
                                <span>Content Creator?</span>
                            </div>
                        </div>
                    </div>

                    <div className='gr-12 brand-ambassadors-hero' style={brandAmbassadorsHeroStyle}>
                        <div className='brand-ambassadors-hero-image'></div>
                        <div className='gr-6 push-1 brand-ambassadors-hero-text'>
                            <p>Unlock the power of</p>
                            <p className='text-emphasis'>Brand Ambassadors</p>
                            <a href='#contact-form'><button>Get Started</button></a>
                        </div>
                    </div>

                    <div className='gr-12 brand-ambassadors-content-container'>
                        <TheModernMarketer isMobile={isMobile} />
                        <PowerOfAuthenticity displayStatic={displayStatic} />
                        <CustomersIntoBrandAmbassadors displayStatic={displayStatic} />
                        <ValueOfTechnology />
                        <UnparalleledBusinessBenefit />
                        <TargetAutomateSave isMobile={isMobile} pageWidth={innerPageWidth} />
                        <EndlessPossibilities displayStatic={displayStatic} page={'brand-ambassadors'} />
                        <ImaginePossibilities />
                        <MeetTheTeam isMobile={isMobile} displayStatic={displayStatic} page={'brand-ambassadors'} />
                        <ContactForm page={'brand-ambassadors'} />
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./web/js/pages/brand_ambassadors.js